import {Row, Col, Form, Button} from 'react-bootstrap';
import {useForm} from 'react-hook-form';
import {useAccountMutations} from './accountMutations';
import withAlerts from '../../lib/withAlerts';
import {compose} from '../../lib/compose';
import {useCustomerContext} from '../../lib/context/customerContext';
import Tooltip from '../tooltip';
import {Can} from '../auth/can';

export const SiteInformationTab = ({alerts = {}}) => {
  const {success, error} = alerts;
  const {register, handleSubmit } = useForm();
  const {updateDescription} = useAccountMutations();
  const {id, name, description, hasPermission} = useCustomerContext();
  const editSiteInfoDisabled = !hasPermission('SITEINFO_EDIT');
  
  const handleDescription = async (formData) => {
    const update = await updateDescription({variables: {
      name: name,
      description: formData?.description
    }});

    if(update?.errors) {
        error({msg: 'There was an error updating the site description. Please try again.'});
    } else {
        success({msg: 'Site description updated.'});
    }
  }
  
  return(
    <Row className="modal-white">
      <Col sm="12" md="6" lg="6">
        <Form onSubmit={handleSubmit(handleDescription)}>
          <div className="account-form modal-body p-3">
            <Form.Group className="mb-3">
              <Form.Label className="strong">Site Account ID</Form.Label>
              <Form.Control
                name="id"
                type="text"
                defaultValue={id}
                disabled
                />
            </Form.Group>

            <Form.Group className="mb-3">
              <Tooltip reverse placement="top" id="tooltip-description" content={"When Customer Administrators at other sites associate an SSID with your site, this is the description/label they will see."}>
                <Form.Label>Site Description</Form.Label>
              </Tooltip>    
              <Form.Control
                {...register("description")}
                type="text"
                defaultValue={description}
                placeholder="Enter a description to identify this site location."
                disabled={editSiteInfoDisabled}
              />
            </Form.Group>
            <Can code="SITEINFO_EDIT">
              <div className="d-flex justify-content-end">
                <Button type="submit" className="ms-2">Submit</Button> 
              </div>
            </Can>
          </div>
        </Form>
      </Col>
    </Row>
  )
};

export default compose(
  withAlerts
)(SiteInformationTab);
